const SEARCH_PLACEHOLDER = "Search for apps & games";
export default SEARCH_PLACEHOLDER;
